<template>
  <div>
    <wc-page-title title='Reports'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Report Setup'
            :titleIcon='headerData.icon'
            :titleIconColor='headerData.iconColor'
            showHelp
            helpText='Please be patient with this page as it may be slow due to the large number of systems loaded.'
          >
            <v-card-text>
              <v-row dense>
                <v-col cols='12' md='3'>
                  <v-select
                    :items='types'
                    label='Filter by'
                    v-model='selection'
                  ></v-select>
                </v-col>
                <v-col cols='12' md='3' offset-md='6'>
                  <v-btn
                    block
                    depressed
                    color='info'
                    :loading='isLoading'
                    :disabled='isLoading'
                    @click='generateReport'
                  >Generate</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </wc-data-box>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12'>
          <irrigation-table
            :systems='systems'
            :isLoading='isLoading'
            :showConflicts="selection === 'F' ? true : false"
            :reportType='selection'
            @openProject='openProjectQuickView'
          ></irrigation-table>
        </v-col>
      </v-row>
    </v-container>

    <wc-dialog
      :showDialog='showDialog'
      :loading='isSaving'
      title='Project Quick View'
      :subtitle='serializerCopy.name'
      width='450'
      :loadingButtons='isSaving'
      @save="save"
      @cancel='showDialog = false'
    >
      <template v-slot:dialog-actions>
        <v-tooltip top open-delay='500'>
          <template v-slot:activator='{ on }'>
            <div v-on='on' class='d-inline-block'>
              <v-btn small outlined text @click='open'>
                Open Project
                <v-icon right small color='grey darken-2'>mdi-open-in-new</v-icon>
              </v-btn>
            </div>
          </template>
          <span class='caption'>Open this project in a new window - This page will remain as is</span>
        </v-tooltip>
      </template>

      <div class='caption font-italic grey--text text--lighten-1'>
        Conflict Status is only used on this page.
      </div>

      <v-text-field
        class='my-4'
        label='Conflict Status Note'
        v-model='serializerCopy.conflict_status'
        maxlength='50'
        counter
        clearable
        hint='Wade, feel free to write whatever you want here for now'
        persistent-hint
      ></v-text-field>

    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import IrrigationReportTable from './IrrigationReportTable'
import projectReportsAPI from '../../api/reports'
import projectsAPI from '@/modules/projects/api/projects'

export default {
  name: 'systems-report',
  data: () => ({
    isLoading: false,
    isSaving: false,
    showDialog: false,
    serializerCopy: {},
    selection: 'A',
    systems: []
  }),
  computed: {
    headerData () {
      return this.$store.state.icons.dataBox.report
    },
    types () {
      return [
        { value: 'A', text: 'All Systems' },
        { value: 'R', text: 'Residential' },
        { value: 'C', text: 'Commercial' },
        { value: 'F', text: 'Has conflicts' },
        { value: 'FB', text: 'Has conflicts - Blowdown Authorized' },
        { value: 'FS', text: 'Has conflicts - Startup Authorized' },
        { value: 'SBP', text: 'Startup and Blowdown Prices' },
        { value: 'OS', text: "Has outstanding service issues"},
        { value: "AR", text: "Project is archived"}
      ]
    }
  },
  components: {
    'irrigation-table': IrrigationReportTable
  },
  methods: {
    async generateReport () {
      this.isLoading = true
      this.systems = []
      this.systems = await projectReportsAPI.getIrrigationSystemsReport(this.selection)
      this.isLoading = false
    },
    openProjectQuickView (project) {
      this.serializerCopy = _.cloneDeep(project) 
      this.showDialog = true
    },
    open () {
      const link = document.createElement('a')
      const invURL = this.$router.resolve({ name: 'IrrigationOverview', params: { id: this.serializerCopy.project_id } })
      link.target = '_blank'
      link.href = invURL.href
      link.click()
    },
    async save () {
      this.isSaving = true
      let obj = { id: this.serializerCopy.project_id, conflict_status: this.serializerCopy.conflict_status }
      let tmp = await projectsAPI.updateProject(obj)
      let index = _.findIndex(this.systems, p => p.project_id == obj.id)
      this.systems[index].conflict_status = tmp.conflict_status
      this.isSaving = false
      this.showDialog = false
    }
  }
}
</script>
